<script>
  // import bulkJson from "../../../Stores/jsonBulkData"
  import DynamicImg from "./dynamicImg.svelte"
  export let fileNames = []
</script>

<div class="w-full space-y-3">
  <h1 class="text-center text-xl font-bold dark:text-white">Dynamic Images Status</h1>
  <div class="max-h-[300px] w-full space-y-1.5 overflow-auto">
    {#each fileNames as docData}
      <DynamicImg {docData} />
    {/each}
  </div>
</div>
